function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import cn from 'classnames';
import { Typography } from 'seagull';
import { AgreementViewCard, Logo, TopStripe } from "./CommonComponents";
import styles from "./SignedHeader.module.scss";
import { relationshipModel, timeModel } from "../../../../models";
import { getSortedFormattedDigitalSignatures } from "../AgreementView.utils";
import { compact } from 'lodash-es';
import DigitalSignature from "../../../../components/DigitalSignature/DigitalSignature";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const DetailsText = props => /*#__PURE__*/_jsx(Typography, _objectSpread({
  ellipsis: true,
  skin: "secondary"
}, props));
export default function SignedHeader(_ref) {
  let {
    relationship,
    brandColor,
    testPrefix
  } = _ref;
  const vendorLogoUrl = relationshipModel.vendorLogoUrl(relationship);
  return /*#__PURE__*/_jsxs(AgreementViewCard, {
    className: cn(styles.signedHeader, {
      [styles.withLogo]: vendorLogoUrl
    }),
    children: [/*#__PURE__*/_jsx(TopStripe, {
      backgroundColor: brandColor
    }), vendorLogoUrl && /*#__PURE__*/_jsx(Logo, {
      logoUrl: vendorLogoUrl
    }), /*#__PURE__*/_jsx("div", {
      className: styles.datesContainer,
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "h6",
        children: "Agreement between"
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.contactDetailsContainer,
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(DetailsText, {
          "data-testid": testPrefix + 'seller-name',
          children: relationshipModel.sellerFullName(relationship)
        }), /*#__PURE__*/_jsx(DetailsText, {
          "data-testid": testPrefix + 'vendor-name',
          children: relationshipModel.vendorName(relationship)
        }), /*#__PURE__*/_jsx(DetailsText, {
          "data-testid": testPrefix + 'seller-email',
          children: relationshipModel.sellerEmail(relationship)
        })]
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(DetailsText, {
          "data-testid": testPrefix + 'buyer-`name',
          children: relationshipModel.buyerFullName(relationship)
        }), /*#__PURE__*/_jsx(DetailsText, {
          "data-testid": testPrefix + 'customer-name',
          children: relationshipModel.customerName(relationship)
        }), /*#__PURE__*/_jsx(DetailsText, {
          "data-testid": testPrefix + 'buyer-email',
          children: relationshipModel.buyerEmail(relationship)
        })]
      })]
    }), relationshipModel.isApproved(relationship) && relationship.approvalRecord ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Typography, {
        variant: "paragraph2",
        skin: "secondary",
        "data-testid": "digital-signature-block-when",
        children: ["This agreement was digitally signed by:", /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      }), getSortedFormattedDigitalSignatures(relationship.approvalRecord, compact(relationship.additionalApprovalRecords)).map(formattedDigitalSignature => /*#__PURE__*/_jsx(DigitalSignature, {
        formattedDigitalSignature: formattedDigitalSignature
      }, formattedDigitalSignature.on + formattedDigitalSignature.ip))]
    }) : /*#__PURE__*/_jsxs(Typography, {
      variant: "paragraph2",
      skin: "secondary",
      "data-testid": "externally-signed-indicator",
      children: ["Existing agreement was uploaded and authorized for billing on Anchor by", ' ', relationshipModel.sellerFullName(relationship), " on", ' ', timeModel.formatDateWithTime(relationship.createdOn)]
    })]
  });
}